module.exports = __webpack_public_path__ + "static/img/14b.187859a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/14b.jpg
// module id = sLZB
// module chunks = 1